import isEmpty from "lodash/isEmpty"
import { arabicToInt } from "../utilities/arabicNumParser"
import {
  countryAgeRequirements,
  countryPhoneRequirements,
  isDateOfBirthValid,
} from "../utilities"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")
  const _country = localStorage.getItem("_country") || "GH"

  // Country-specific requirements for age
  const requiredAge = countryAgeRequirements[_country] || 18
  // Country-specific requirements for phone
  const requiredPhoneLength = countryPhoneRequirements[_country] || 12

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    lb: {
      message_required: `This field is required`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_digits_only = {
    fr: {
      message_required: `Entrez uniquement des chiffres`,
    },
    en: {
      message_required: `Enter digits only`,
    },
    sw: {
      message_required: `Ingiza tarakimu pekee`,
    },
    ZARMA: {
      message_required: `Hantum  lambayze hinne`,
    },
    HAOUSSA: {
      message_required: `Rubuta ỳan ƙilgo kaɗay`,
    },
    es: {
      message_required: `Inserta solo dígitos`,
    },
    lb: {
      message_required: `Enter digits only`,
    },
    ar: {
      message_required: `ادخال أرقام فقط`,
    },
    pt: {
      message_required: `Insira apenas dígitos`,
    },
  }

  const lang_text_only = {
    fr: {
      message_required: `Entrer seulement du texte`,
    },
    en: {
      message_required: `Enter text only`,
    },
    sw: {
      message_required: `Ingiza herufi pekee`,
    },
    ZARMA: {
      message_required: `Zarma for Enter text only`,
    },
    HAOUSSA: {
      message_required: `Rubuta matani kaɗay`,
    },
    es: {
      message_required: `Inserta solo texto`,
    },
    lb: {
      message_required: `Enter text only`,
    },
    ar: {
      message_required: `ادخال احرف/ كلمات فقط`,
    },
    pt: {
      message_required: `Insira apenas texto`,
    },
  }

  const lang_pin_length = {
    fr: {
      message_required: `Le code PIN doit comporter 4 chiffres`,
    },
    en: {
      message_required: `Pin should be 4 digits`,
    },
    sw: {
      message_required: `PIN mwisho tarakimu 4`,
    },
    ZARMA: {
      message_required: `Zarma for PIN mwisho tarakimu 4`,
    },
    HAOUSSA: {
      message_required: `ỳan ƙilgo hudu kaday ke cikin lamban kanki`,
    },
    es: {
      message_required: `El pin debe tener 4 dígitos`,
    },
    lb: {
      message_required: `Pin should be 4 digits`,
    },
    ar: {
      message_required: `الرمز من ٤ أرقام فقط`,
    },
    pt: {
      message_required: `O PIN deve ter 4 dígitos`,
    },
  }

  const lang_pin_mismatch = {
    fr: {
      message_required: `Erreur de code PIN`,
    },
    en: {
      message_required: `Pin does not match`,
    },
    sw: {
      message_required: `PIN haifanani`,
    },
    ZARMA: {
      message_required: `Zarma for Pin does not match`,
    },
    HAOUSSA: {
      message_required: `Lamban ki na kanki ta bambanta`,
    },
    es: {
      message_required: `El pin no coincide`,
    },
    lb: {
      message_required: `Pin does not match`,
    },
    ar: {
      message_required: `الرمز غير مطابق`,
    },
    pt: {
      message_required: `O PIN não corresponde`,
    },
  }

  const lang_phone_max_length = {
    fr: {
      message_required: `Le numéro de téléphone doit comporter ${requiredPhoneLength} chiffres`,
    },
    en: {
      message_required: `Phone number should be ${requiredPhoneLength} digits`,
    },
    sw: {
      message_required: `Namba ya simu mwisho ni tarakimu ${requiredPhoneLength}`,
    },
    ZARMA: {
      message_required: `Zarma for Phone number should be ${requiredPhoneLength} digits`,
    },
    HAOUSSA: {
      message_required: `ỳan ƙilgo ${requiredPhoneLength} ke cikin lamba waya`,
    },
    es: {
      message_required: `El número de teléfono debe tener ${requiredPhoneLength} dígitos`,
    },
    lb: {
      message_required: `Phone number should be ${requiredPhoneLength} digits`,
    },
    pt: {
      message_required: `O número de telefone deve ter ${requiredPhoneLength} dígitos`,
    },
    ar: {
      message_required: `رقم الهاتف يجب ان يكون من ١٠ أرقام`,
    },
  }

  const min_date_msg = {
    fr: {
      message_required: `Format de date invalide ou ne répond pas aux exigences d'âge minimum de ${requiredAge} ans`,
    },
    en: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    sw: {
      message_required: `Muundo wa tarehe si sahihi au haukidhi mahitaji ya chini ya umri wa miaka ${requiredAge}`,
    },
    ZARMA: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    HAOUSSA: {
      message_required: `Tsarin kwanan wata mara inganci ko bai cika mafi ƙarancin shekarun buƙatun shekaru ${requiredAge} ba`,
    },
    es: {
      message_required: `Formato de fecha no válido o no cumple con los requisitos de edad mínima de ${requiredAge} años.`,
    },
    lb: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    pt: {
      message_required: `Formato de data inválido ou não atende aos requisitos de idade mínima de ${requiredAge} anos`,
    },
    ar: {
      message_required: `تنسيق التاريخ غير صالح أو لا يستوفي متطلبات الحد الأدنى للعمر وهو ${requiredAge} عامًا`,
    },
  }

  let errors = {}
  const letters = /^[A-zÀ-ú\-\\' \u0600-\u06FF]+$/

  if (data.gender === "") {
    errors.gender = lang_required[lang_code].message_required
  }
  if (data.full_name === "") {
    errors.full_name = lang_required[lang_code].message_required
  } else if (!data.full_name.match(letters)) {
    errors.full_name = lang_text_only[lang_code].message_required
  }

  if (data.pin === "") {
    errors.pin = lang_required[lang_code].message_required
  }

  if (data.confirm_pin === "") {
    errors.confirm_pin = lang_required[lang_code].message_required
  }

  if (data.confirm_pin !== data.pin) {
    errors.pin = lang_pin_mismatch[lang_code].message_required
    errors.confirm_pin = lang_pin_mismatch[lang_code].message_required
  }

  if (lang_code === "ar") {
    if (isNaN(arabicToInt(data.pin))) {
      errors.pin = lang_digits_only[lang_code].message_required
    }
  } else if (isNaN(data.pin)) {
    errors.pin = lang_digits_only[lang_code].message_required
  }

  if (lang_code === "ar") {
    if (isNaN(arabicToInt(data.confirm_pin))) {
      errors.confirm_pin = lang_digits_only[lang_code].message_required
    }
  } else if (isNaN(data.confirm_pin)) {
    errors.confirm_pin = lang_digits_only[lang_code].message_required
  }

  if (data.pin.length !== 4) {
    errors.pin = lang_pin_length[lang_code].message_required
  }

  if (data.confirm_pin.length !== 4) {
    errors.confirm_pin = lang_pin_length[lang_code].message_required
  }

  if (data.phone_number.length !== requiredPhoneLength) {
    errors.phone_number = lang_phone_max_length[lang_code].message_required
  }

  if (!isDateOfBirthValid(data.date_of_birth, requiredAge)) {
    errors.date_of_birth = min_date_msg[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
